import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import LoginPage from './pages/LoginPage'
import ClientPortal from './pages/ClientPortal'
import AdminDashboard from './pages/AdminDashboard'
import './index.css'

function TopNav() {
  const { profile, signOut } = useAuth()
  return (
    <nav className="topnav">
      <div className="topnav-logo">
        <img src="/logo_vet1.png" alt="VET1 IT" />
        <div>
          <div className="topnav-logo-text">VET1 IT</div>
          <div className="topnav-logo-sub">Support Portal</div>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 'auto' }}>
        <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)' }}>{profile?.company_name}</span>
        <button className="btn btn-signout btn-sm" onClick={signOut}>Sign out</button>
      </div>
    </nav>
  )
}

function ProtectedRoute({ children, adminOnly }) {
  const { user, profile, loading } = useAuth()
  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <span className="spinner" />
    </div>
  )
  if (!user) return <Navigate to="/login" replace />
  if (adminOnly && !profile?.is_admin) return <Navigate to="/" replace />
  return children
}

function AppRoutes() {
  const { user, profile, loading } = useAuth()

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <span className="spinner" />
    </div>
  )

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={
        <ProtectedRoute>
          <div className="page-wrapper">
            <TopNav />
            <main className="main-content">
              {profile?.is_admin ? <AdminDashboard /> : <ClientPortal />}
            </main>
          </div>
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}
